import React, { FC } from 'react'
import styled from 'styled-components'
import { LoaderSize, spinningLoaderIconsMap } from './svgs/spinningLoaderIconsMap'

export type Props = {
  size?: LoaderSize
  className?: string
  title?: string
}

const Loader: FC<Props> = ({ size = 'large', ...rest }) => {
  // We cannot just scale one svg to different sizes, because browser deforms them
  // when scaling, and it ends up looking shit in
  const SelectedIcon = spinningLoaderIconsMap[size]

  return <SelectedIcon {...rest} />
}

const LoaderStyledComponent = styled(Loader)``

export { LoaderStyledComponent as Loader }

export type LoaderProps = Props
